export const CLOSE_EVENT = 'closePopover'
export const listStyle = "max-height: 30vh; overflow-y: scroll;"
